import { render, staticRenderFns } from "./MedicineForm.vue?vue&type=template&id=15d9d648&scoped=true"
import script from "./MedicineForm.vue?vue&type=script&lang=js"
export * from "./MedicineForm.vue?vue&type=script&lang=js"
import style0 from "./MedicineForm.vue?vue&type=style&index=0&id=15d9d648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d9d648",
  null
  
)

export default component.exports